import { WFH } from "../actionTypes";
import { deepClone } from "../../utils/global_functions";


export const getWfhTouchlineLastTick = (payload) => (dispatch, getState) => {
    try {
        const objTouchlineLastTick = deepClone(getState()?.wfh?.objTouchlineLastTick);

        if (objTouchlineLastTick) {
            return objTouchlineLastTick;
        } else {
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
};
export const getWfhBestFiveLastTick = (payload) => (dispatch, getState) => {
    try {
        const objBestFiveLastTick = getState()?.wfh?.objBestFiveLastTick;
        if (objBestFiveLastTick) {
            return objBestFiveLastTick;
        } else {
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
};

export const updateWfhTouchlineLastTick = (payload) => {
    return { type: WFH.UPDATE_TOUCHLINE_LAST_TICK, payload };
};

export const updateWfhBestFiveLastTick = (payload) => {
    return { type: WFH.UPDATE_BESTFIVE_LAST_TICK, payload };
};


// Shuaib : 21/02/2024: Reconnection attempts - Start

export const updateTouchlineObj = (payload) => {
    return { type: WFH.UPDATE_TOUCHLINE_OBJ, payload };
};

export const updateBestFiveObj = (payload) => {
    return { type: WFH.UPDATE_BEST_FIVE_OBJ, payload };
};

export const updateReconnectionCount = (payload) => {
    return { type: WFH.UPDATE_RECONNECTION_COUNT, payload };

};
// Shuaib : 21/02/2024: Reconnection attempts - End